import { ThemeParameters, RuntimeThemeParameters } from '../../types';
import { graphSelection } from './';

// These are overridden by the derived focus properties of DesignTokens if they exist.
export const graphFocus = (theme: ThemeParameters, parameters: RuntimeThemeParameters) => {
  switch (theme.baseThemeName) {
    case 'high-contrast': {
      return {
        lineColor: graphSelection(theme, parameters).lineColor,
        lineStyle: 'dotted',
        lineThickness: '5px',
      };
    }
    default: {
      return {
        lineColor: graphSelection(theme, parameters).lineColor,
        lineStyle: 'dashed',
        lineThickness: '1px',
      };
    }
  }
};
